"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Admin = _interopRequireDefault(require("@rsuite/icon-font/lib/people/Admin"));

// Generated by script, don't edit it please.
var Admin = (0, _createSvgIcon["default"])({
  as: _Admin["default"],
  ariaLabel: 'admin',
  category: 'people',
  displayName: 'Admin'
});
var _default = Admin;
exports["default"] = _default;
module.exports = exports.default;